<template>
  <svg
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_10580_11713)">
      <path
        d="M32.5078 11.0491C28.169 11.0491 23.9276 12.3357 20.32 14.7462C16.7124 17.1567 13.9006 20.5829 12.2402 24.5915C10.5798 28.6 10.1454 33.0109 10.9918 37.2664C11.8383 41.5218 13.9277 45.4307 16.9957 48.4987C20.0637 51.5667 23.9726 53.6561 28.228 54.5025C32.4835 55.349 36.8944 54.9146 40.9029 53.2542C44.9115 51.5938 48.3377 48.782 50.7482 45.1744C53.1587 41.5668 54.4453 37.3254 54.4453 32.9866C54.4392 27.1703 52.1259 21.5939 48.0132 17.4812C43.9004 13.3685 38.3241 11.0552 32.5078 11.0491ZM41.0613 34.3745L30.0926 41.9683C29.8394 42.1434 29.5431 42.2459 29.2358 42.2647C28.9285 42.2834 28.6219 42.2178 28.3492 42.0748C28.0766 41.9319 27.8482 41.7171 27.6889 41.4536C27.5296 41.1902 27.4453 40.8882 27.4453 40.5803V25.3928C27.4453 25.085 27.5296 24.783 27.6889 24.5195C27.8482 24.2561 28.0766 24.0413 28.3492 23.8983C28.6219 23.7553 28.9285 23.6897 29.2358 23.7085C29.5431 23.7273 29.8394 23.8298 30.0926 24.0049L41.0613 31.5986C41.2858 31.7538 41.4693 31.9612 41.5961 32.203C41.7228 32.4447 41.789 32.7136 41.789 32.9866C41.789 33.2595 41.7228 33.5284 41.5961 33.7702C41.4693 34.0119 41.2858 34.2193 41.0613 34.3745Z"
        fill="#FFE2E2"
      />
    </g>
    <defs>
      <clipPath id="clip0_10580_11713">
        <rect
          width="54"
          height="54"
          fill="white"
          transform="translate(0.445312 0.924072)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
